import React from 'react';
import { ChakraProvider } from '@chakra-ui/provider';
import { theme } from './theme';

type OllieThemeProviderProps = {
  children: React.ReactNode;
};

export const OllieThemeProvider = ({ children }: OllieThemeProviderProps) => {
  return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
};
